import { couponService } from 'shared/src/api';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { queryKey } from '../../../constant/queryKey';
import { bridge } from 'shared/src/utils';

export const usePostRedeemCoupon = (marketId: number) => {
  const client = useQueryClient();
  return useMutation({
    throwOnError: false,
    mutationFn: (params: { sno: number }) =>
      couponService.postRedeemCoupon(params.sno),
    onSuccess: () => {
      const marketDetailCouponKey = queryKey.marketCoupon(marketId);
      const marketDetailKey = queryKey.marketDetail(marketId);
      client.invalidateQueries({
        predicate: query =>
          (query.queryKey[0] === marketDetailCouponKey[0] &&
            query.queryKey[1] === marketDetailCouponKey[1] &&
            query.queryKey[2] === marketDetailCouponKey[2]) ||
          (query.queryKey[0] === marketDetailKey[0] &&
            query.queryKey[1] === marketDetailKey[1]),
      });
    },
    onError: error => {
      bridge.toast(error.message);
    },
  });
};
